<template>
  <v-container fluid class="pt-1">
    <v-layout column wrap>
      <customer-image class="mb-3" :file="value.organization_chart" v-model="value.image" />
      <v-text-field
        outline
        :label="$t('code')"
        data-vv-name="code"
        v-model="value.code"
        v-validate="'required'"
        :data-vv-as="$t('code')"
        :error-messages="errors.collect('code')"
      />
      <v-text-field
        outline
        :label="$t('name')"
        data-vv-name="name"
        v-model="value.name"
        v-validate="'required'"
        :data-vv-as="$t('name')"
        :error-messages="errors.collect('name')"
      />
      <v-combobox
        outline
        multiple
        small-chips
        :label="$t('phones')"
        v-model="value.phones"
      />
      <v-textarea
        outline
        rows="0"
        auto-grow
        v-model="value.address"
        :label="$t('description')"
      />

      <v-checkbox
        :label="$t('disable_back_date')"
        v-model="value.disable_back_date"
      />
    </v-layout>
    <v-btn color="primary" class="mx-0" @click="save" :loading="loading">
      {{ $t("save") }}
    </v-btn>
  </v-container>
</template>

<script>
import { customersMixin } from "@/mixins/index.js";

export default {
  props: ["value"],
  data: () => ({
    loading: false,
  }),
  mixins: [customersMixin],
  methods: {
    save() {
      this.loading = true;
      this.$validator.validateAll().then((succeed) => {
        if (succeed) {
          this.axios.post("branches", this.value).then((res) => {
            this.loading = false;
            this.value.id = res.data.id;
            this.$store.commit("showSnackbar", {
              text: this.$t("save_succeed"),
              stateType: "success",
              show: true,
            });
            this.getCustomers();
            this.$emit("saved", res.data);
          });
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true,
          });
        }
      });
    },
  },
  watch: {
    value: function () {
      this.$emit("input", this.value);
    },
  },
};
</script>